// https://javascript.plainenglish.io/how-to-setup-and-add-google-analytics-to-your-react-app-fd361f47ac7b

import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
const RouteChangeTracker = () => {
  const location = useLocation();
  useEffect(
    function () {
      const path = location.pathname + location.search;
      ReactGA.set({ page: path });
      ReactGA.send(path); // Record a pageview for the given page
    },
    [location]
  );
  return <></>;
};
export default RouteChangeTracker;
